import React from 'react';
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { SERVER } from '../../../config'
import history from '../../../core/history'
import { cx, trackEventLog } from '../../../core/utils'
import icClear from './ic_Clear.png'
import icSearch from './ic_Search.png'
import icSearchActive from './ic_Search_Active.png'
import s from './index.css';

class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputVal: '',
      searchType: '',
      showDel: false,
      searchSuggest: [],
      focusIdx: -1,
      showContent: false,
      icSearchState: 0, // 0表示搜索框blur状态，1表示focus状态
    }
    this.suggestTimeout = null
    this.blurTimeout = null
  }

  fetchSuggest = (val) => {
    const { fetch } = this.context
    fetch(`${SERVER}suggest?n=5&q=${window.encodeURIComponent(val)}`)
    .then(res => res.json())
    .then((resData) => {
      const { msg, data } = resData
      if (msg !== 'success') return
      this.setState({
        searchType: 'suggest',
        focusIdx: -1,
        searchSuggest: data,
      })
    })
  }

  handleFocus = () => {
    trackEventLog('w/header/searchbar')
    const { inputVal, searchType } = this.state
    this.setState({
      showContent: true,
      icSearchState: 1,
      showDel: !!inputVal,
    })
    window.clearTimeout(this.blurTimeout)
    if (inputVal || searchType === 'history') return
    this.setState({
      searchType: 'history',
      focusIdx: -1,
    })
  }

  handleBlur = () => {
    this.setState({
      icSearchState: 0,
    })
    this.blurTimeout = window.setTimeout(() => {
      this.setState({
        searchType: '',
        showDel: false,
        focusIdx: -1,
      })
    }, 150)
  }

  handleChange = () => {
    // if (this.searchInput.value.length > 16) return
    this.setState({ inputVal: this.searchInput.value })
    window.clearTimeout(this.suggestTimeout)
    this.suggestTimeout = window.setTimeout(() => {
      const searchVal = this.searchInput.value;
      const trimVal = searchVal.trim()
      if (trimVal) {
        this.setState({
          showDel: true,
        })
        this.fetchSuggest(trimVal)
        window.clearTimeout(this.suggestTimeout)
        return
      }
      this.setState({
        searchType: 'history',
        focusIdx: -1,
        showDel: false,
      })
    }, 300)
  }

  clickItem = (item) => {
    this.setState({
      inputVal: '',
      searchType: '',
      focusIdx: -1,
    })
    const wd = item.replace(/<\/?[^>]+>/gi, '')
    trackEventLog(`w/header/search/${wd}`)
    history.push(`/search/${wd}`)
  }

  handleSearch = () => {
    const { searchHistory } = this.props
    const { focusIdx, searchSuggest, searchType } = this.state
    const itemArr = searchType === 'suggest' ?
    searchSuggest : searchHistory
    let searchVal = this.searchInput.value
    if (focusIdx >= 0) {
      searchVal = itemArr[focusIdx]
    }
    if (!searchVal.trim()) return
    this.clickItem(searchVal)
    this.searchInput.blur()
    trackEventLog('w/header/search')
    window.clearTimeout(this.suggestTimeout)
  }

  handleKeyDown = (e) => {
    const code = e.keyCode
    const { searchHistory } = this.props
    const { focusIdx, searchSuggest, searchType } = this.state
    const itemArr = searchType === 'suggest' ?
      searchSuggest : searchHistory
    const itemLen = itemArr.length

    if (code === 13) { // enter键：搜索
      this.handleSearch()
    } else if (code === 38) { // 上箭头
      e.preventDefault()
      if (focusIdx < 0) return
      this.setState({
        focusIdx: focusIdx - 1,
      })
    } else if (code === 40) {
      e.preventDefault()
      if (focusIdx >= itemLen - 1) return
      this.setState({
        focusIdx: focusIdx + 1,
      })
    }
  }
  renderSearch() {
    const { deleteSearchHistory, searchHistory } = this.props;
    const { searchType, searchSuggest, showContent, focusIdx } = this.state;
    switch (searchType) {
      case 'history':
        if (!searchHistory || !searchHistory.length) return null
        return (
          <div
            className={`${s.historyCont} ${showContent ? s.show : ''}`}
          >
            {searchHistory.map((item, idx) => (
                <div // eslint-disable-line
                  className={cx({
                    [`${s.historyItem}`]: true,
                    [`${s.focusItem}`]: idx === focusIdx,
                  })}
                  key={`history-item-${idx}`} // eslint-disable-line
                  onClick={() => {
                    trackEventLog('w/header/search/history')
                    this.clickItem(item)
                  }}
                >{ item }</div>
              ))}
            <div // eslint-disable-line
              className={s.delHistory}
              onClick={() => {
                if (searchHistory.length && window.confirm('确定清空搜索历史吗？')) { // eslint-disable-line
                  deleteSearchHistory()
                }
              }}
            >
              <span className={s.deleteIcon} />
              <span>清空搜索历史</span>
            </div>
          </div>
        )
      case 'suggest':
        if (!searchSuggest.length) {
          return null
        }
        return (
          <div
            className={`${s.suggestCont} ${showContent ? s.show : ''}`}
          >
            {
              searchSuggest.map((item, idx) => (
                <div // eslint-disable-line jsx-a11y/no-static-element-interactions
                  className={cx({
                    [`${s.suggestItem}`]: true,
                    [`${s.focusItem}`]: idx === focusIdx,
                  })}
                  key={`search-suggest-${item + idx}`}
                  onClick={() => {
                    trackEventLog('w/header/search/suggest')
                    this.clickItem(item)
                  }}
                >{ item }</div>
              ))
            }
          </div>
        )
      default:
        return null
    }
  }
  render() {
    const { icSearchState, inputVal, showDel } = this.state
    return (
      <div className={s.container}>
        <img
          onClick={this.handleSearch}
          className={s.searchIcon}
          src={icSearchState ? icSearchActive : icSearch}
          alt={''}
        />
        <input
          type={'text'}
          className={s.input}
          ref={(ref) => { this.searchInput = ref }}
          placeholder={'输入课程或者老师名称'}
          value={inputVal}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
        />
        {showDel ?
        <img // eslint-disable-line
          src={icClear}
          className={s.clearIcon}
          onClick={() => {
            this.setState({
              inputVal: '',
            })
            window.setTimeout(() => {
              this.searchInput.focus()
            }, 0)
          }}
          alt={'清空'}
        /> : null}
        {this.renderSearch()}
      </div>
    );
  }
}

SearchBox.propTypes = {
  searchHistory: PropTypes.array.isRequired,
  deleteSearchHistory: PropTypes.func.isRequired,
};

SearchBox.contextTypes = {
  fetch: PropTypes.func,
}

export default withStyles(s)(SearchBox);



// WEBPACK FOOTER //
// ./src/components/global/SearchBox/index.js